(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ee-campaign-media"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ee-campaign-media')) {
    customElements.define('ee-campaign-media', class extends HTMLElement {
      connectedCallback() { this.frame = requestAnimationFrame(() => this.initialize()); }
      initialize() {
        this.cleanup();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.video = this.querySelector('video');
        this.button = this.querySelector('.ee-campaign__playback');
        this.controls = this.querySelector('.ee-campaign__controls');
        this.sound = this.querySelector('.ee-campaign__sound');
        if (!this.video || !this.sound) return;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.userPaused = false;
        this.manualStarted = false;
        this.video.controls = false;
        this.video.muted = true;
        this.classList.add('is-enhanced');
        this.controls.hidden = false;
        this.updateButton();
        this.sound.addEventListener('click', () => { this.video.muted = !(this.video.muted || this.video.volume === 0); if (!this.video.muted && this.video.volume === 0) this.video.volume = 1; if (this.video.paused) { this.manualStarted = true; this.play(); } this.updateButton(); }, options);
        this.video.addEventListener('volumechange', () => this.updateButton(), options);
        this.video.addEventListener('playing', () => {
          if (document.hidden || this.stillOnMobile()) { this.stop(); return; }
          this.classList.add('has-started');
          this.updateButton();
        }, options);
        this.video.addEventListener('pause', () => this.updateButton(), options);
        this.video.addEventListener('error', () => {
          this.classList.remove('has-started');
          this.stop();
          this.controls.hidden = true;
        }, options);
        this.mobile.addEventListener('change', () => this.sync(), options);
        this.reduced.addEventListener('change', () => {
          this.manualStarted = false;
          this.sync();
        }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= .15);
            this.sync();
          }, { threshold: .15 });
          this.observer.observe(this);
        } else { this.visible = true; this.sync(); }
      }
      stillOnMobile() { return this.dataset.mobileStill === 'true' && this.mobile.matches; }
      sync() {
        const automatic = this.dataset.autoplay === 'true' && !this.reduced.matches && !navigator.connection?.saveData && !window.Shopify?.designMode;
        if (!this.visible || document.hidden || this.stillOnMobile() || this.userPaused || (!automatic && !this.manualStarted)) {
          this.stop();
        } else if (this.video.paused) this.play();
      }
      async play() {
        if (!this.isConnected || document.hidden || this.stillOnMobile()) return;
        try {
          await this.video.play();
        } catch (_) {
          // Keep the poster when browser autoplay is blocked.
        }
        this.updateButton();
      }
      stop() {
        this.video?.pause();
        this.updateButton();
      }
      updateButton() {
        if (!this.sound || !this.video) return;
        const muted = this.video.muted || this.video.volume === 0;
        this.sound.setAttribute('aria-label', muted ? 'Unmute film' : 'Mute film');
        this.sound.querySelector('[data-icon="muted"]').hidden = !muted;
        this.sound.querySelector('[data-icon="sound"]').hidden = muted;
      }
      cleanup() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.stop();
      }
      disconnectedCallback() { cancelAnimationFrame(this.frame); this.cleanup(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-category-shop"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ee-category-shop'))customElements.define('ee-category-shop',class extends HTMLElement{
 connectedCallback(){
 this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;
 const tabs=[...this.querySelectorAll('[data-tab]')],panels=[...this.querySelectorAll('[data-panel]')];if(!tabs.length)return;
 this.querySelector('nav').setAttribute('role','tablist');
 const activate=(index,focus=false)=>{tabs.forEach((t,i)=>{t.setAttribute('aria-selected',String(i===index));t.tabIndex=i===index?0:-1});panels.forEach((p,i)=>p.hidden=i!==index);if(focus)tabs[index].focus()};
 tabs.forEach((t,i)=>{t.id=t.dataset.tab+'-tab';t.setAttribute('role','tab');t.setAttribute('aria-controls',t.dataset.tab);panels[i].setAttribute('role','tabpanel');panels[i].setAttribute('aria-labelledby',t.id);panels[i].tabIndex=0;
 t.addEventListener('click',e=>{e.preventDefault();activate(i)}, {signal});
 t.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else if(e.key===' '){e.preventDefault();activate(i);return}else return;e.preventDefault();activate(n,true)}, {signal});});
 this.addEventListener('shopify:block:select',e=>{const i=panels.indexOf(e.target.closest('[data-panel]'));if(i>=0)activate(i)}, {signal});activate(0);
 }
 disconnectedCallback(){this.abort?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-eclipse-reveal"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('ee-eclipse-reveal')) {
    customElements.define('ee-eclipse-reveal', class extends HTMLElement {
      connectedCallback() { this.frame = requestAnimationFrame(() => this.initialize()); }
      initialize() {
        this.cleanup();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.stage = this.querySelector('.ee-reveal__stage');
        this.runway = this.querySelector('.ee-reveal__runway');
        this.object = this.querySelector('.ee-reveal__object');
        this.left = this.querySelector('.ee-reveal__half--left');
        this.right = this.querySelector('.ee-reveal__half--right');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.failed = false;
        if (!this.stage || !this.runway || !this.object) return;
        const queue = () => { if (!this.pending) this.pending = requestAnimationFrame(() => { this.pending = 0; this.draw(); }); };
        window.addEventListener('scroll', queue, { signal, passive: true });
        window.addEventListener('resize', queue, { signal, passive: true });
        this.motion.addEventListener('change', queue, { signal });
        this.querySelectorAll('img').forEach(img => {
          img.addEventListener('load', queue, { signal });
          img.addEventListener('error', () => { this.failed = true; queue(); }, { signal });
          if (img.complete && !img.naturalWidth) this.failed = true;
        });
        this.resize = new ResizeObserver(queue);
        this.resize.observe(this.stage);
        this.draw();
      }
      draw() {
        const active = this.dataset.ready === 'true' && this.dataset.motion === 'true' && !this.motion.matches && !this.failed && this.left && this.right;
        this.classList.toggle('is-scroll-linked', Boolean(active));
        if (!active) {
          [this.left, this.right, this.object].forEach(el => { el?.style.removeProperty('transform'); el?.style.removeProperty('opacity'); });
          this.progress = 1;
          return;
        }
        const height = this.stage.getBoundingClientRect().height;
        const header = document.querySelector('.shopify-section-header-sticky');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const top = Math.max(headerHeight + 12, (window.innerHeight - height) / 2);
        this.style.setProperty('--ee-stage-size', `${height}px`);
        this.style.setProperty('--ee-sticky-top', `${top}px`);
        const distance = Math.max(1, parseFloat(getComputedStyle(this).getPropertyValue('--ee-reveal-distance')) || 600);
        const raw = Math.max(0, Math.min(1, (top - this.runway.getBoundingClientRect().top) / distance));
        this.progress = raw;
        // A short closed hold at entry and open hold at exit make both states readable.
        const p = Math.max(0, Math.min(1, (raw - .08) / .82));
        const eased = p * p * (3 - 2 * p);
        this.left.style.transform = `translateX(${-48 * eased}%)`;
        this.right.style.transform = `translateX(${48 * eased}%)`;
        this.left.style.opacity = this.right.style.opacity = String(1 - .94 * eased);
        const reveal = Math.max(0, Math.min(1, (p - .15) / .75));
        this.object.style.opacity = String(reveal);
        this.object.style.transform = `translateY(${18 * (1-reveal)}px) scale(${.96 + .04*reveal})`;
      }
      cleanup() { this.controller?.abort(); this.resize?.disconnect(); cancelAnimationFrame(this.pending); this.pending = 0; }
      disconnectedCallback() { cancelAnimationFrame(this.frame); this.cleanup(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-jewelry-index"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ee-jewelry-index')) {
    customElements.define('ee-jewelry-index', class extends HTMLElement {
      connectedCallback() { this.frame = requestAnimationFrame(() => this.initialize()); }
      initialize() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const rows = [...this.querySelectorAll('[data-ee-row]')];
        const panels = [...this.querySelectorAll('[data-ee-panel]')];
        const finePointer = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const select = (row) => {
          if (!row || !panels.some((panel) => panel.id === row.dataset.panel)) return;
          // Keep a focused image or shop link present while keyboard users interact with it.
          if (panels.some((panel) => !panel.hidden && panel.contains(document.activeElement))) return;
          const changed = !row.classList.contains('is-active');
          rows.forEach((item) => {
            item.classList.toggle('is-active', item === row);
            item.querySelector('button')?.setAttribute('aria-pressed', String(item === row));
          });
          panels.forEach((panel) => {
            panel.getAnimations?.().forEach((animation) => animation.cancel());
            panel.hidden = panel.id !== row.dataset.panel;
            if (!panel.hidden && changed && !reducedMotion() && panel.animate) {
              panel.animate([{ opacity: .4, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 360, easing: 'ease-out' });
            }
          });
        };
        rows.forEach((row) => {
          const button = row.querySelector('button');
          if (button) {
            button.hidden = false;
            button.addEventListener('click', () => select(row), options);
          }
          row.addEventListener('pointerenter', () => { if (finePointer()) select(row); }, options);
          row.addEventListener('focusin', () => select(row), options);
        });
        this.addEventListener('shopify:block:select', (event) => {
          select(rows.find((row) => row.dataset.blockId === event.detail?.blockId));
        }, options);
      }
      disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-perspectives"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ee-perspectives')) {
    customElements.define('ee-perspectives', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const buttons = [...this.querySelectorAll('[data-ee-view]')];
        const panels = [...this.querySelectorAll('[data-ee-panel]')];
        const controls = this.querySelector('.ee-perspectives__controls');
        if (controls) controls.hidden = false;
        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            if (button.getAttribute('aria-pressed') === 'true') return;
            buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
            panels.forEach((panel) => {
              panel.getAnimations?.().forEach((animation) => animation.cancel());
              panel.hidden = panel.id !== button.dataset.eeView;
              if (!panel.hidden && !reducedMotion() && panel.animate) {
                panel.animate([{ opacity: .4, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 350, easing: 'ease-out' });
              }
            });
          }, { signal: this.controller.signal });
        });
        if (this.dataset.reveal !== 'true' || reducedMotion() || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            if (!reducedMotion() && entry.target.animate) {
              entry.target.animate([{ opacity: .4, transform: 'translateY(22px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 650, easing: 'cubic-bezier(.2,.7,.2,1)' });
            }
            this.observer.unobserve(entry.target);
          });
        }, { threshold: .12 });
        this.querySelectorAll('[data-ee-reveal]').forEach((element) => this.observer.observe(element));
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-worn-reveal"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ee-worn-reveal'))customElements.define('ee-worn-reveal',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;this.selected='worn';this.hovering=false;
  const buttons=[...this.querySelectorAll('[data-select]')];const frame=this.querySelector('.ee-worn__frame');const images=[...this.querySelectorAll('[data-view]')];
  const show=view=>{this.dataset.active=view;buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.select===view)));images.forEach(i=>i.setAttribute('aria-hidden',String(i.dataset.view!==view)))};
  this.querySelector('.ee-worn__buttons').hidden=false;
  buttons.forEach(b=>b.addEventListener('click',()=>{this.selected=b.dataset.select;show(this.selected)}, {signal}));
  frame.addEventListener('pointerenter',e=>{if(this.dataset.hover==='true'&&e.pointerType==='mouse'){this.hovering=true;show('piece')}},{signal});
  frame.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'){this.hovering=false;show(this.selected)}},{signal});
  show(this.selected);
 }
 disconnectedCallback(){this.abort?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
